export const EncountersOutletName = 'encounters';

export enum EncountersRoutes {
  Root = '',
  New = 'new'
}
